import { c as _c } from "react/compiler-runtime";
import "client-only";
import { type Ref, useCallback, useLayoutEffect, useRef } from "react";
import { setRef } from "@/vendors/Snowplow/utilities/set-ref";

// TEMPORARY: SHOULD BE DELETED WHEN V1 IS REMOVED
export function useMergedRefs(...t0) {
  const $ = _c(3);
  const refs = t0;
  const refsRef = useRef(refs);
  let t1;
  if ($[0] !== refs) {
    t1 = () => {
      refsRef.current = refs;
    };
    $[0] = refs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useLayoutEffect(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = element => {
      for (const ref of refsRef.current) {
        if (ref) {
          setRef(ref, element);
        }
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}